import { forwardRef } from 'react';
import styles from './NewsletterValidator.module.scss';

const NewsletterValidator = forwardRef(({ btn, error, className, ...rest }, ref) => (
	<>
		<input {...rest} className={`form-control mt-3 ${styles.input} ${className || ''}`} ref={ref} />
		{btn && (
			<button className={`btn btn-input mt-2 ${styles.submit}`} type="submit" id="submitnewsletter">
				{btn}
			</button>
		)}
		{error && (
			<div className="invalid-feedback" data-test-id="invalid-feedback">
				{error}
			</div>
		)}
	</>
));

NewsletterValidator.displayName = 'NewsletterValidator';
export default NewsletterValidator;
